module.exports = __webpack_public_path__ + "static/media/attachment_blue_active.093b4a92.svg";